import { buildQuery, IFilter, IPage } from "@/api/api.ts";
import { API_URL } from "@/config";
import axios from "axios";
import { DBStoreOrder, IAddress, IStore } from "./store";

const API = `${API_URL}/profile`;

interface IUserAddress extends IAddress {
    id: number;
    user_id: number;
}

export interface SalesInfo {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
}

export interface IUser {
    first_name: string;
    last_name: string;
    email: string;
    user_address: IUserAddress;
    is_admin: boolean;
    is_driver: boolean;
    is_sales: boolean;
    store_terms_accepted?: boolean;
    driver_terms_accepted?: boolean;
    driver_coverage_expires_at?: string;
    has_logged_in?: boolean;
    last_active?: string;
}

export interface IDriverOrder extends DBStoreOrder {
    store?: IStore;
    pickup_address?: IAddress;
}

export interface UserType extends IUser {
    id: number;
}

export const getProfile = async () => {
    const result: { data: UserType } = await axios.get(`${API}`);
    return result.data;
};

export const updateProfile = async (data: UserType) => {
    const result: { data: UserType } = await axios.put(`${API}`, data);
    return result.data;
};

export const getProfileStores = async (page: number = 1, size: number = 50) => {
    const result = await axios.get<IPage<IStore>>(
        `${API}/store/accounts?page=${page}&size=${size}`
    );
    return result.data;
};

export const getSalesStores = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter
) => {
    const result = await axios.get<IPage<IStore>>(
        `${API}/store/rep?page=${page}&size=${size}&${buildQuery(filter)}`
    );
    return result.data;
};

export const getDriverOrders = async (
    page: number = 1,
    size: number = 50,
    filter: IFilter
) => {
    const result = await axios.get<IPage<IDriverOrder>>(
        `${API}/orders/working-on?page=${page}&size=${size}&${buildQuery(filter)}`
    );
    return result.data;
};

export const getCompletedOrders = async (
    page: number = 1,
    size: number = 50,
    filter: IFilter
) => {
    const result = await axios.get<IPage<IDriverOrder>>(
        `${API}/orders/completed?page=${page}&size=${size}&${buildQuery(filter)}`
    );
    return result.data;
};

export const acceptOrder = async (id: number) => {
    const result: { data: IDriverOrder } = await axios.put(
        `${API}/orders/${id}/accept`
    );
    return result.data;
};
